import {
  BRAZIL_DELAY_OPTIONS,
  BRAZIL_DELAY_OPTIONS_WITH_TRANSLATIONS,
  DEFAULT_DELAY_OPTIONS,
  DEFAULT_DELAY_OPTIONS_WITH_TRANSLATIONS,
  SAUDI_DELAY_OPTIONS,
  SAUDI_DELAY_OPTIONS_WITH_TRANSLATIONS,
  TR_SHY_CANCELLED_OPTIONS,
  TR_SHY_CANCELLED_OPTIONS_WITH_TRANSLATIONS,
  TR_SHY_DELAYED_OPTIONS,
  TR_SHY_DELAYED_OPTIONS_WITH_TRANSLATIONS,
  TR_SHY_OVERBOOKED_OPTIONS,
  TR_SHY_OVERBOOKED_OPTIONS_WITH_TRANSLATIONS,
  US_GOODWILL_DELAY_OPTIONS,
  US_GOODWILL_DELAY_OPTIONS_WITH_TRANSLATIONS,
} from "../../settings/constants";
import { Delay } from "../types/intake-funnel";
import { ClaimDetails } from "../../funnels/pre-eligibility/state/preEligibilityState";

type TotalDelayOptions = Readonly<Array<Delay>>;
type DelayOptionsWithTranslations = Partial<Record<Readonly<Delay>, string>>;

export function useDelayOptions({
  potentialRegulation,
  claimType,
}: {
  potentialRegulation: ClaimDetails["potentialRegulation"];
  claimType: ClaimDetails["claimType"];
}): {
  options: TotalDelayOptions;
  optionsWithTranslations: DelayOptionsWithTranslations;
} {
  let options: TotalDelayOptions = DEFAULT_DELAY_OPTIONS;
  let optionsWithTranslations: DelayOptionsWithTranslations =
    DEFAULT_DELAY_OPTIONS_WITH_TRANSLATIONS;

  if (potentialRegulation === "brazil") {
    options = BRAZIL_DELAY_OPTIONS;
    optionsWithTranslations = BRAZIL_DELAY_OPTIONS_WITH_TRANSLATIONS;
  }

  if (potentialRegulation === "saudi_arabia") {
    options = SAUDI_DELAY_OPTIONS;
    optionsWithTranslations = SAUDI_DELAY_OPTIONS_WITH_TRANSLATIONS;
  }

  if (potentialRegulation === "us_goodwill") {
    options = US_GOODWILL_DELAY_OPTIONS;
    optionsWithTranslations = US_GOODWILL_DELAY_OPTIONS_WITH_TRANSLATIONS;
  }

  if (potentialRegulation === "tr_shy") {
    if (claimType === "delayed") {
      options = TR_SHY_DELAYED_OPTIONS;
      optionsWithTranslations = TR_SHY_DELAYED_OPTIONS_WITH_TRANSLATIONS;
    }
    if (claimType === "cancelled") {
      options = TR_SHY_CANCELLED_OPTIONS;
      optionsWithTranslations = TR_SHY_CANCELLED_OPTIONS_WITH_TRANSLATIONS;
    }
    if (claimType === "overbooked") {
      options = TR_SHY_OVERBOOKED_OPTIONS;
      optionsWithTranslations = TR_SHY_OVERBOOKED_OPTIONS_WITH_TRANSLATIONS;
    }
  }

  return {
    options,
    optionsWithTranslations,
  };
}
